import React, {useMemo} from "react";
import Dropdown from "./index";
import {countryList} from "../../../_data/country-list";
import {useTranslation} from "../../../hooks/useTranslation";

const Flag = ({ code, size = 32 }) => {
    return (
        <img
            src={`/assets/images/countries/${code.toLowerCase()}.svg`}
            width={size}
            height={size * 0.75}
            alt=""
            loading="lazy"
            decoding="async"
        />
    );
}

const CountryDropdown = ({label, selected, onChange, className, includeNone = false}) => {
    const {t, locale} = useTranslation();

    const countryOptions = useMemo(() => {
        const options = countryList.map((o) => {
            const countryLabel = t(`Countries.${o.code}`);
            return {
                value: o.code,
                label: (
                    <React.Fragment>
                        <Flag code={o.code} size={18}/>{" "}{countryLabel}
                    </React.Fragment>
                ),
                searchText: countryLabel,
            };
        });
        return includeNone ? [{label: "Κενό", value: ""}, ...options] : options;
    }, [locale]);

    return (
        <div style={{minWidth: "180px"}}>
            <Dropdown
                name={"countrySelection"}
                label={label || "Χώρα"}
                searchEnable={true}
                options={countryOptions}
                className={className}
                defaultValue={countryOptions.find((el) => el.value === selected)}
                onChange={(e) => onChange(e.value)}
            />
        </div>
    )
}

export default CountryDropdown;
